import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
import 'reactflow/dist/style.css';
import './styles.css';
import ReactFlowWidget from './ReactFlowWidget';


// Declarar tipos globais para o serviço de comunicação
declare global {
    interface Window {
        webComponentCommunication?: {
            receiveDataFromWebComponent: (data: any) => void;
            data$: any;
        };
    }
}

const ReactFlowWebComponent = r2wc(ReactFlowWidget, {
    props: { apiResponse: {} as any }
});

// Registrar o Web Component no navegador
customElements.define('react-flow', ReactFlowWebComponent);

export default ReactFlowWebComponent;